import type { ClarityDashboardTab } from './clarity-dashboard-tabs.constant';

/**
 * The URL segment of a domain's Integrations tab: `/clarity/d/:domainId/integrations`.
 *
 * Used as both the route path and the tab id. Distinct from `CLARITY_INTEGRATIONS_ROUTE_SEGMENT`
 * (`/clarity/settings/integrations`).
 */
export const CLARITY_DOMAIN_INTEGRATIONS_ROUTE_SEGMENT = 'integrations' satisfies ClarityDashboardTab;
